/**
 * True when the GraphQL HTTP URL targets a FirstTable Stellate hostname.
 * Used to decide whether Stellate-only headers (e.g. rate-limit bypass) may be sent.
 */
export function isStellateEndpoint(endpoint?: string): boolean {
  if (!endpoint) return false;
  try {
    const { hostname } = new URL(endpoint);

    if (hostname === 'stellate.firsttable.net') {
      return true;
    }

    if (!hostname.endsWith('.stellate.sh')) {
      return false;
    }

    const firstDotIndex = hostname.indexOf('.');
    const firstLabel =
      firstDotIndex === -1 ? hostname : hostname.slice(0, firstDotIndex);
    return firstLabel.startsWith('firsttable-');
  } catch {
    return false;
  }
}
